import { render, staticRenderFns } from "./ActionsIndex.vue?vue&type=template&id=6f4d60ea&scoped=true&"
import script from "./ActionsIndex.vue?vue&type=script&lang=js&"
export * from "./ActionsIndex.vue?vue&type=script&lang=js&"
import style0 from "./ActionsIndex.vue?vue&type=style&index=0&id=6f4d60ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4d60ea",
  null
  
)

export default component.exports